import { ColorsV2 } from 'app/constants/color';

const { Box, Typography, IconButton, styled, TextField } = require('@mui/material');

export const Container = styled(Box)({
  height: '100%',
  marginTop: '64px',
  padding: '30px 30px 30px 30px ',
});

export const Title = styled(Typography)({
  fontFamily: 'DM Sans,sans-serif',
  fontWeight: 700,
  fontSize: '1em',
  lineHeight: '31.25px',
  letterSpacing: '0.1px',
  color: '#526380',
  padding: '8px',
});

export const CustomIconButton = styled(IconButton)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 'none',
  width: '30px',
  height: '30px',
});

export const CustomTextField = styled(TextField)({
  width: '90%',
  '& .MuiOutlinedInput-input': {
    color: ColorsV2.white,
    border: `1px solid ${ColorsV2.outline}`,
    borderRadius: '5px',
    fontSize: '0.7em',
  },
  '& .MuiOutlinedInput-input:focus': {
    color: ColorsV2.white,
    border: `1px solid ${ColorsV2.acent}`,
    borderRadius: '5px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
  '& .Mui-disabled': {
    cursor: 'not-allowed',
  },
  '& .MuiInputBase-input.Mui-disabled': {
    WebkitTextFillColor: ColorsV2.white,
  },
});
